{% block prems_premium_item_info_banner %}
    <div id="prems-premium-item-info-banner"></div>
{% endblock %}